<template>
  <div>
    <div v-if="loading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
      <app-form v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.isEdit,
        isAdvanceEdit: this.isAdvanceEdit,
        pmAssessmentRecordReviewList: this.pmAssessmentRecordReviewList,
      }" v-on:error="errorHandler"/>

      <div v-if="isErr">
        <app-error v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"/>
      </div>
    </div>
  </div>
</template>

<script>
import PMAssessmentRecordFormStaff from "../../../components/performance/assessmentrecord/FormStaff";
import moment from 'moment';
import ErrorDialog from '../../../components/common/ErrorDialog';

export default {
  components: {
    "app-form": PMAssessmentRecordFormStaff,
    'app-error': ErrorDialog
  },

  data() {
    return {
      pageTitle: this.$t('pmassementrecord.adveditpmassessmentrecord'),
      pageTitleValue: '',
      id: this.$route.params.id,

      formData: {
        id: this.$route.params.id,
        pmassessmentrecordcode:null,
        pmassessmentrecorddesc: null,
        startdate: null,
        enddate: null,
        cutoffdate: null,
        statusid: null,
        ratingtype: null,
        ratingid:null,
        ratingcode: null,
        ramark:null,
        pmassecalmethodid: null,
        stamp: null,
        userid: this.$store.getters.userId,
        statusdesc:null,
        ratingtypename:null,
        calculationmethodname : null
      },
      errMsg: "",
      isErr: false,
      loading: true,
      isEdit: true,
      isAdvanceEdit:true,
      pmAssessmentRecordReviewList: [],
    };
  },

  methods: {

    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    async loadPerformanceAssessmentRecordHandler() {
      this.isErr = false;
      this.errMsg = "";

      try {
          const res = await this.$store.dispatch('get', { url: `/performanceassessmentrecord/${this.id}` });

          if (res.status === 200 && res.data.rec) {
              this.formData = { ...res.data.rec };
              if (this.formData.startdate) {
                  this.formData.startdate = moment(this.formData.startdate).format('YYYY-MM-DD');
              }
              if (this.formData.enddate) {
                  this.formData.enddate = moment(this.formData.enddate).format('YYYY-MM-DD');
              }
              if (this.formData.cutoffdate) {
                this.formData.cutoffdate = moment(this.formData.cutoffdate).format('YYYY-MM-DD');
              }
              this.formData.userid = this.$store.getters.userId;
          } else {
              this.isErr = true;
              console.error("data not found");
              this.errMsg = "Record not found.";
          }
      } catch (err) {
          console.error("Error loading record:", err);
          this.isErr = true;
          this.errMsg = err.message || "Network Error";
      }
    },

    async loadPMAssessmentRecordReviewsHandler() {
        try {
            const res = await this.$store.dispatch('get', { url: "/performanceassessmentrecordreviews/" + this.id });
            this.pmAssessmentRecordReviewList = res.data.rec;

            this.pmAssessmentRecordReviewList.forEach(item => {
                if (item.startdate) {
                    item.startdate = moment(item.startdate).format('YYYY-MM-DD');
                }
                if (item.enddate) {
                    item.enddate = moment(item.enddate).format('YYYY-MM-DD');
                }
                //getting item data from the table, with column name as the item.name
            });
        } catch (err) {
            this.isErr = true;
            this.errMsg = err;
        }
    },
    
  },

  async mounted() {
    try {
        await this.loadPerformanceAssessmentRecordHandler();
        await this.loadPMAssessmentRecordReviewsHandler();
        this.loading = false; // Set loading to false after all data is loaded
    } catch (error) {
        console.error("Something went wrong during mounted:", error);
        this.isErr = true;
        this.errMsg = error;
    }
  }

};
</script>